<template>
  <a-flex
    align="center"
    justify="center"
    :style="{ paddingRight: layoutStore.navWidth + 'px', marginTop: '50px' }"
  >
    <a-card class="container-wrapper">
      <a-flex vertical>
        <a-form
          ref="formRef"
          :model="formState"
          name="password_change"
          layout="vertical"
          autocomplete="off"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
        >
          <a-form-item
            label="Текущий пароль"
            name="oldPassword"
            :rules="[{ required: true, message: 'Введите текущий пароль!' }]"
          >
            <a-input-password
              v-model:value="formState.oldPassword"
              placeholder="Старый пароль"
            ></a-input-password>
          </a-form-item>

          <a-form-item
            label="Новый пароль"
            name="newPassword"
            :rules="[
              { required: true, message: 'Введите новый пароль!' },
              { min: 8, message: 'Пароль должен быть минимум 8 символов!' },
              { validator: validatePasswordMatch },
            ]"
          >
            <a-input-password
              v-model:value="formState.newPassword"
              placeholder="Новый пароль"
            ></a-input-password>
          </a-form-item>

          <a-form-item
            label="Повторите новый пароль"
            name="newPasswordConfirm"
            :rules="[
              { required: true, message: 'Повторите новый пароль!' },
              { validator: validatePasswordConfirmMatch },
            ]"
          >
            <a-input-password
              v-model:value="formState.newPasswordConfirm"
              placeholder="Повторите новый пароль"
            ></a-input-password>
          </a-form-item>
        </a-form>

        <a-flex justify="space-between" align="center" class="actions">
          <a-form-item>
            <router-link :to="{ name: 'profile' }">
              <a-button>Назад</a-button>
            </router-link>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="submit" @click="submitForm">
              Сохранить
            </a-button>
          </a-form-item>
        </a-flex>
      </a-flex>
    </a-card>
  </a-flex>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { Rule, FormInstance } from "ant-design-vue/es/form";
import { createNotification } from "@/tools/notification";
import { useUser } from "@/stores/user/user";
import { useBaseLayout } from "@/stores/baseLayout";

interface FormState {
  oldPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
}

const formState = ref<FormState>({
  oldPassword: "",
  newPassword: "",
  newPasswordConfirm: "",
});

const formRef = ref<FormInstance>();

const userStore = useUser();
const layoutStore = useBaseLayout();

const validatePasswordConfirmMatch: Rule["validator"] = async (_, value) => {
  if (
    value &&
    value !== formState.value.newPassword &&
    formState.value.newPassword
  ) {
    return Promise.reject("Пароли не совпадают!");
  }
  return Promise.resolve();
};

const validatePasswordMatch: Rule["validator"] = async (_, value) => {
  if (
    value &&
    value !== formState.value.newPasswordConfirm &&
    formState.value.newPasswordConfirm
  ) {
    return Promise.reject("Пароли не совпадают!");
  }
  return Promise.resolve();
};

const submitForm = () => {
  formRef.value
    ?.validate()
    .then(() => {
      onFinish(formState.value);
    })
    .catch((errorInfo) => {
      onFinishFailed(errorInfo);
    })
    .finally(() => {
      formState.value = {
        oldPassword: "",
        newPassword: "",
        newPasswordConfirm: "",
      };
    });
};

const onFinish = async (values: FormState) => {
  await userStore.changePassword(values.oldPassword, values.newPasswordConfirm);
};

const onFinishFailed = (errorInfo: { errorFields: { errors: string[] }[] }) => {
  createNotification("error", errorInfo.errorFields[0].errors[0]);
};
</script>

<style scoped lang="scss">
.container-wrapper {
  width: 450px;
}

.actions {
  margin-top: 10px;
  gap: 15px;

  & > .ant-form-item {
    flex: 1 1 50%;

    .ant-btn {
      width: 100%;
    }
  }
}
</style>
